import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { checkPlayable, battleOfTheHunsId, christmasId } from "../../../../common/parameters";

import routing from "../../../routing";
import Icons from "../../../icons";
import AdSense from "../../../components/AdSense";
import TaskSwitch from "../../../components/TaskSwitch";

import TaskCard from "../TaskCard";
import { ITaskPreviewProps } from "../TaskCard/interfaces";

import {
    StyledTasks,
    StyledDivider,
    AddTaskHolder,
    EmptyPlan,
    NoPreview,
    AboveMobileAdSense,
    AsideAdSense,
    BelowAdSense,
} from "./styles";
import messages from "./messages";
import NewTaskModal from "./NewTaskModal";
import { IProps } from "./interfaces";
import DonateBanner from "../../../components/DonateBanner";

const Tasks = ({
    publicView,
    plan,
    plan: { tasks },
    simulation,
    pulsatingNewTask,
    moderatorView,
}: IProps) => {
    const [newTaskOpen, setNewTaskOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSetLoading = (loading: boolean) => {
        setLoading(loading);
    };

    const isExtra = plan._id === battleOfTheHunsId || plan._id === christmasId;
    return (
        <div>
            <StyledDivider>
                {publicView && !moderatorView && (
                    <AboveMobileAdSense>
                        <AdSense width={320} slot="PublicTest_AboveTasks-Mobile" />
                    </AboveMobileAdSense>
                )}
                <StyledTasks publicView={publicView}>
                    {tasks.length === 0 && (
                        <EmptyPlan>
                            <h3>
                                <FormattedMessage {...messages.emptyTest} />
                            </h3>
                        </EmptyPlan>
                    )}
                    {isExtra && (
                        <NoPreview>
                            <FormattedMessage {...messages.noPreview} />
                        </NoPreview>
                    )}
                    {!isExtra &&
                        tasks.map((task, index) => {
                            let playable = checkPlayable(task, plan);
                            const Task = TaskSwitch(task.type) as unknown as (props: ITaskPreviewProps) => JSX.Element;
                            let Icon = Icons[task.type];
                            return (
                                <TaskCard
                                    key={task.id}
                                    Task={Task}
                                    Icon={Icon}
                                    publicView={publicView}
                                    playable={playable}
                                    moderatorView={!!moderatorView}
                                    plan={plan}
                                    index={index}
                                    tasks={tasks}
                                    simulation={!!simulation}
                                    loading={loading}
                                    setLoading={handleSetLoading}
                                />
                            );
                        })}
                    {!publicView && (
                        <div>
                            <AddTaskHolder>
                                <button
                                    className={cn("button", "button--light", "button--thin", pulsatingNewTask && "pulsate")}
                                    onClick={() => {
                                        if (!simulation) {
                                            setNewTaskOpen(true);
                                        }
                                    }}
                                >
                                    + <FormattedMessage {...messages.newTask} />
                                </button>
                                <Link
                                    to={`/${routing.plan}/${plan._id}/${routing.scores}`}
                                    className={cn("button", pulsatingNewTask && "pulsate")}
                                    style={{ marginLeft: 16 }}
                                    onClick={e => simulation && e.preventDefault()}
                                >
                                    <FormattedMessage {...messages.generateTasks} />
                                </Link>
                            </AddTaskHolder>
                            {newTaskOpen && (
                                <NewTaskModal close={() => {
                                    setNewTaskOpen(false);
                                }} plan={plan} />
                            )}
                        </div>
                    )}
                </StyledTasks>
                {publicView && !moderatorView && (
                    <AsideAdSense>
                        <DonateBanner />
                        {/* <AdSense slot="PublicView_AsideTasks" height="100%" /> */}
                    </AsideAdSense>
                )}
            </StyledDivider>
            {publicView && !moderatorView && (
                <BelowAdSense>
                    <AdSense height={150} slot="PublicView_BelowTasks" />
                </BelowAdSense>
            )}
        </div>
    );
}

export default Tasks;
